import Axios from "axios";
import Vue from "@/main";

// var baseUrl = "http://10.20.17.191:9920";//铁道警察
// var baseUrl = "https://lsb.mianyang.djszkj.com/";//绵阳项目
// var baseUrl = "http://szsjht.zzjtxy.com";//郑州交通技师学院项目
// var baseUrl = "http://szksjzx1.peczzu.edu.cn";//郑大思政
// var baseUrl = "https://lsb.tdjcxy.djszkj.com";//铁道警察
// var baseUrl = "https://lsb.dszk.djszkj.com";//大思政课
var baseUrl = "http://mindcol.sxjdzy.cn";//陕西机电
//新增获取精神谱系时长
Axios.getMindContentTime = `${baseUrl}/ds1/tasked/getMindContentTime`; // 获取精神谱系的任务时长和完成时长
Axios.updateTaskedTimeMindByMind = `${baseUrl}/ds1/tasked/updateTaskedTimeMindByMind`; // 更新持续任务的时间（不包括精神谱系）

//20231111，新增评价和钉钉授权

Axios.isAllowRate = `${baseUrl}/ds1/user2/isAllowRate`; // 当前是否可以进行评价
Axios.getTeaStuPreRateList = `${baseUrl}/ds1/user2/getTeaStuPreRateList`; // 获取所有教师对学员评价的可选列表
Axios.getStuTeaPreRateList = `${baseUrl}/ds1/user2/getStuTeaPreRateList`; // 获取所有学员对教师评价的可选列表
Axios.stuRateTea = `${baseUrl}/ds1/user2/stuRateTea`; // 学员提交对教师的评价
Axios.teaRateStu = `${baseUrl}/ds1/user2/teaRateStu`; // 教师提交对学员的评价
Axios.getStuListByTea = `${baseUrl}/ds1/user2/getStuListByTea`; // 教师获取学生列表
Axios.getStuListByTeaCount = `${baseUrl}/ds1/user2/getStuListByTeaCount`; // 教师获取学生列表行数
Axios.getTeasByStu = `${baseUrl}/ds1/user2/getTeasByStu`; // 获取当前学员的所有教师
Axios.dingLogin = `${baseUrl}/ds1/user/dingLogin`; // 获取钉钉信息

Axios.bases = `${baseUrl}`;
Axios.login = `${baseUrl}/ds1/user/login`; // 登录接口
// Axios.logout = `${baseUrl}/ds1/user/logout`; // 用户登出
// Axios.passwd = `${baseUrl}/ds1/user/passwd`; // 修改密码
// Axios.getVrTypeInfo = `${baseUrl}/ds1/user/getVrTypeInfo`; // 首页获取VR体验分类信息
Axios.getPolicyType = `${baseUrl}/ds1/user/getPolicyType`; // 首页获取方针政策的分类信息
Axios.getPolicy = `${baseUrl}/ds1/user/getPolicy`; // 获取方针政策列表
Axios.getColEmpower = `${baseUrl}/ds1/user/getColEmpower`; // 获取校区授权情况
// Axios.signin = `${baseUrl}/ds1/user/signin`; // 签到
// Axios.getVoviByMap = `${baseUrl}/ds1/user/getVoviByMap`; // 根据省份获取全景资源列表
// Axios.getVoviByType = `${baseUrl}/ds1/user/getVoviByType`; // 根据分类获取全景资源列表
// Axios.getVoviUrl = `${baseUrl}/ds1/user/getVoviUrl`; // 获取全景页面url
Axios.getPolicyDetail = `${baseUrl}/ds1/user/getPolicyDetail`; // 获取政策详情内容
Axios.getHelpTxt = `${baseUrl}/ds1/user/getHelpTxt`; // 获取帮助信息
// Axios.getMindClazzList = `${baseUrl}/ds1/user/getMindClazzList`; // 获取思政课程列表

// Axios.getMindClazzChapterList = `${baseUrl}/ds1/user/getMindClazzChapterList`; // 获取思政课程章节列表
Axios.getMindClazzChapterDetail = `${baseUrl}/ds1/user/getMindClazzChapterDetail`; // 获取思政课程章节详情
Axios.getClazzMindTypeList = `${baseUrl}/ds1/user/getClazzMindTypeList`; // 获取课程思政分类列表
Axios.getClazzMindList = `${baseUrl}/ds1/user/getClazzMindList`; // 获取课程思政列表
Axios.getClazzMindDetail = `${baseUrl}/ds1/user/getClazzMindDetail`; // 获取课程思政详情
// Axios.getMovieList = `${baseUrl}/ds1/user/getMovieList`; // 获取影视列表

// Axios.editPhone = `${baseUrl}/ds1/user/editPhone`; // 用户修改手机号码
// Axios.uploadF = `${baseUrl}/uploadF`; // 上传图片
Axios.uploadF = `${baseUrl}/ds1/user2/uploadOther`; // 上传图片
// Axios.changeAvatar = `${baseUrl}/ds1/user/changeAvatar`; // 修改头像
// Axios.commitTeaTask = `${baseUrl}/ds1/user/commitTeaTask`; // 教师下发任务
// Axios.taskQuaCommitTask = `${baseUrl}/ds1/user/taskQuaCommitTask`; // 教师下发任务
// Axios.getStuTaskedList = `${baseUrl}/ds1/user/getStuTaskedList`; // 学生获取任务列表
// Axios.getTesThemType = `${baseUrl}/ds1/clazz/getTesThemType`; // 教师获取任务地点列表
// Axios.getTeaTaskTplList = `${baseUrl}/ds1/user/getTeaTaskTplList`; // 教师获取虚拟仿VR真列表
// Axios.correctTasked = `${baseUrl}/ds1/user/correctTasked`; // 教师批阅任务
// Axios.correctReport = `${baseUrl}/ds1/user/correctReport`; // 教师批阅实践报告
// Axios.getStuListByTasked = `${baseUrl}/ds1/user/getStuListByTasked`; // 教师通过任务获取学生列表
// Axios.taskedOffByTea = `${baseUrl}/ds1/user/taskedOffByTea`; // 教师通过任务获取学生列表
// Axios.getStuTaskedDetailByTea = `${baseUrl}/ds1/user/getStuTaskedDetailByTea`; // 教师获取学生的任务详情
// Axios.getAdviseScore = `${baseUrl}/ds1/user/getAdviseScore`; // 教师获取建议分数
// Axios.getCommentListSelect = `${baseUrl}/ds1/user/getCommentListSelect`; // 教师获取评语列表
// Axios.getTeaTaskTplDetail = `${baseUrl}/ds1/user/getTeaTaskTplDetail`; // 教师获取任务模板详情
// Axios.getStuTaskedDetail = `${baseUrl}/ds1/user/getStuTaskedDetail`; // 学生获取任务详情
// Axios.stuCommitTasked = `${baseUrl}/ds1/user/stuCommitTasked`; // 学生提交任务
// Axios.commitReport = `${baseUrl}/ds1/user/commitReport`; // 学生提交实践报告
// Axios.getStuTaskedScore = `${baseUrl}/ds1/user/getStuTaskedScore`; // 学生获取任务分数
// Axios.getStuTaskedReport = `${baseUrl}/ds1/user/getStuTaskedReport`; // 学生获取任务评定报告
// Axios.getStuTermReport = `${baseUrl}/ds1/user/getStuTermReport`; // 学生获取学期报告
// Axios.getReadOnline = `${baseUrl}/ds1/user/getReadOnline`; // 学生获取在线研读内容
Axios.taskQuaThemType = `${baseUrl}/ds1/user/taskQuaThemType2`; // 获取精品任务主题类型信息
// Axios.taskQuaMoive = `${baseUrl}/ds1/user/taskQuaMoive`; // 获取在线观影信息
// Axios.taskQuaVovi = `${baseUrl}/ds1/user/taskQuaVovi`; // 获取全景信息
// Axios.taskQuaCommit = `${baseUrl}/ds1/user/taskQuaCommit`; // 获取全景信息
Axios.getMindClazzListCount = `${baseUrl}/ds1/user/getMindClazzListCount`; // 获取课程思政列表行数

// Axios.getTaskedListByTeaCount2 = `${baseUrl}/ds1/user/getTaskedListByTeaCount2`; //
// Axios.getMovieSeriesListCount = `${baseUrl}/ds1/user/getMovieSeriesListCount`; // 影视列表行数
// Axios.getPolicyCount = `${baseUrl}/ds1/user/getPolicyCount`; // 方针政策列表行数
// Axios.getVoviTypeInfoWithPageCount = `${baseUrl}/ds1/user/getVoviTypeInfoWithPageCount`; // 全景类型列表行数
// Axios.getMovieTypeListByPageCount = `${baseUrl}/ds1/user/getMovieTypeListByPageCount`; // 影视类型列表行数
// Axios.getClazzMindTypeListByPage = `${baseUrl}/ds1/user/getClazzMindTypeListByPage`; // 影视类型列表行数
// Axios.getClazzMindTypeListByPageCount = `${baseUrl}/ds1/user/getClazzMindTypeListByPageCount`; // 影视类型列表行数
Axios.getMindClazzChapterListCount = `${baseUrl}/ds1/user/getMindClazzChapterListCount`; // 获取思政课程章节列表行数
Axios.getClazzMindListCount = `${baseUrl}/ds1/user/getClazzMindListCount`; // 获取课程思政列表行数
// Axios.getTeaTaskTplListCount = `${baseUrl}/ds1/user/getTeaTaskTplListCount`; // 方针政策列表行数
// Axios.getTeaVRListCount = `${baseUrl}/ds1/user/getTeaVRListCount`; // 全景类型列表行数
// Axios.getTeaMovieListCount = `${baseUrl}/ds1/user/getTeaMovieListCount`; // 影视类型列表行数
// Axios.getTeaVoviListCount = `${baseUrl}/ds1/user/getTeaVoviListCount`; // 影视类型列表行数
// Axios.getTeaTaskedListCount = `${baseUrl}/ds1/user/getTeaTaskedListCount`; // 影视列表行数
// Axios.getStuTaskedListCount = `${baseUrl}/ds1/user/getStuTaskedListCount`; // 获取课程思政列表行数
// Axios.getTaskedListByTeaCount = `${baseUrl}/ds1/user/getTaskedListByTeaCount`; // 教师获取所有任务列表的行数
Axios.getStuIdByTaskedId = `${baseUrl}/ds1/user/getStuIdByTaskedId`; //
// Axios.taskQuaMoiveCount = `${baseUrl}/ds1/user/taskQuaMoiveCount`; // 影视类型列表行数
// Axios.taskQuaVoviCount = `${baseUrl}/ds1/user/taskQuaVoviCount`; // 省份和对应全景数量
// Axios.getStuListByTaskedCount = `${baseUrl}/ds1/user/getStuListByTaskedCount`; // 获取思政课程章节列表行数
// Axios.getReadOnline = `${baseUrl}/ds1/user/getReadOnline`; // 获取在线研读内容
// Axios.getVoviUrl = `${baseUrl}/ds1/user/getVoviUrl`; // 获取在线研读内容
// Axios.getclazzMindDomain = `${baseUrl}/ds1/user/getclazzMindDomain`; // 获取课程思政资源登录地址
Axios.getSiteInfo = `${baseUrl}/ds1/user/getSiteInfo`; // 获取网站信息
// Axios.getAllProfList = `${baseUrl}/ds1/user/getAllProfList`; // 获取教师所带班级的所有专业
// Axios.getAllClazzList = `${baseUrl}/ds1/user/getAllClazzList`; // 获取教师所带的所有班级，根据专业进行过滤
// Axios.getVrInfoList = `${baseUrl}/ds1/user/getVrInfoList`; // 教师获取虚拟仿真VR
// Axios.getMovieSeriesSelect = `${baseUrl}/ds1/user/getMovieSeriesSelect`; // 教师获取影视剧集下拉列表

// Axios.getActiviReport = `${baseUrl}/ds1/user/getActiviReport`; // 学生获取实践报告内容
// Axios.taskedIsChecked = `${baseUrl}/ds1/user/taskedIsChecked`; //
// Axios.getTaskedListByTea = `${baseUrl}/ds1/user/getTaskedListByTea`; // 教师获取所有任务列表
// Axios.getMovieSelect = `${baseUrl}/ds1/user/getMovieSelect`; // 教师获取影视下拉列表
// Axios.getAllGradeList = `${baseUrl}/ds1/user/getAllGradeList`; // 获取教师所带班级的级别列表，根据专业和院系过滤
// Axios.getTaskedListByTea2 = `${baseUrl}/ds1/user/getTaskedListByTea2`; //
// Axios.getReadOnlineContentTime = `${baseUrl}/ds1/user/getReadOnlineContentTime`; // 获取在线研读的内容和时间
// Axios.getMovieTime = `${baseUrl}/ds1/user/getMovieTime`; // 获取在线观影时间任务时长和完成时长
// Axios.getVoviContentTime = `${baseUrl}/ds1/user/getVoviContentTime`; //
// Axios.updateTaskedTime = `${baseUrl}/ds1/user/updateTaskedTime`; //
// Axios.saveDetail = `${baseUrl}/ds1/user/saveDetail`; //
// Axios.getScoreByTea = `${baseUrl}/ds1/user/getScoreByTea`; //
// Axios.getStuScoreByTaskedIdCount = `${baseUrl}/ds1/user/getStuScoreByTaskedIdCount`; //
// Axios.getTermScoreListCount = `${baseUrl}/ds1/user/getTermScoreListCount`; //
// Axios.getMovieDetailx = `${baseUrl}/ds1/user/getMovieDetailx`; //
// Axios.getTermReportListStuCount = `${baseUrl}/ds1/user/getTermReportListStuCount`; //
// Axios.getStuScoreByTaskedId = `${baseUrl}/ds1/user/getStuScoreByTaskedId`; //
// Axios.generateScore = `${baseUrl}/ds1/user/generateScore`; //
// Axios.getTermScoreList = `${baseUrl}/ds1/user/getTermScoreList`; //
// Axios.taskQuaMoiveType = `${baseUrl}/ds1/user/taskQuaMoiveType`; //
// Axios.taskQuaMoiveSeries = `${baseUrl}/ds1/user/taskQuaMoiveSeries`; //
// Axios.taskQuaMoive = `${baseUrl}/ds1/user/taskQuaMoive`; //
// Axios.taskQuaVoviType = `${baseUrl}/ds1/user/taskQuaVoviType`; //
// Axios.taskQuaVovi = `${baseUrl}/ds1/user/taskQuaVovi`; //
// Axios.getTermReportListStu = `${baseUrl}/ds1/user/getTermReportListStu`; //
// Axios.getTermReportInfo = `${baseUrl}/ds1/user/getTermReportInfo`; //
Axios.getStuTaskedDetailByTea2 = `${baseUrl}/ds1/user/getStuTaskedDetailByTea2`; //

// Axios.exchangePoint = `${baseUrl}/ds1/user/exchangePoint`; //
// Axios.getTip = `${baseUrl}/ds1/user/getTip`; //
// Axios.getTermInfoByTea = `${baseUrl}/ds1/user/getTermInfoByTea`; //

Axios.getCode = `${baseUrl}/ds1/user/getCode`; //
Axios.forgetPwd = `${baseUrl}/ds1/user/forgetPwd`; //

// Axios.getTeachPlan = `${baseUrl}/ds1/mind/getChapterDetail`; // 获取精神谱系内容
Axios.getMindType = `${baseUrl}/ds1/mind/getMindType`; // 精神谱系
Axios.getMindByType = `${baseUrl}/ds1/mind/getMindByType`; // 根据精神谱系分类获取精神谱系
Axios.getMindDetail = `${baseUrl}/ds1/mind/getMindDetail`; // 根据精神谱系分类获取精神谱系

// Axios.getFirstChapter = `${baseUrl}/ds1/mind/getFirstChapter`; // 获取课程章节的1级分类
// Axios.getTestDetailByClazz = `${baseUrl}/ds1/mind/getTestDetailByClazz`; // 通过课程章节获取测试题内容（默认作业）
// Axios.commitWork = `${baseUrl}/ds1/mind/commitWork`; // 通过课程章节获取测试题内容（默认作业）
// Axios.commitTestByClass = `${baseUrl}/ds1/mind/commitTestByClass`; // 教师按照章节上传试题
// Axios.getTeacherData = `${baseUrl}/ds1/mind/getTeacherData`; // 领导获取教师的相关数据
// Axios.getTaskData = `${baseUrl}/ds1/mind/getTaskData`; // 领导获取实践相关数据
// Axios.getResource = `${baseUrl}/ds1/mind/getResource`;
// Axios.getWorkData = `${baseUrl}/ds1/mind/getWorkData`;  // 领导获取作业相关数据
// Axios.getWorkScoreListTea = `${baseUrl}/ds1/mind/getWorkScoreListTea`; // 教师查看自己的学生成绩
// Axios.generaTermWorkScore = `${baseUrl}/ds1/mind/generaTermWorkScore`; // 教师查看自己的学生成绩
// Axios.getWorkListStu = `${baseUrl}/ds1/mind/getWorkListStu`; // 教师按照章节上传试题
// Axios.getTermListStu = `${baseUrl}/ds1/mind/getTermListStu`; // 学生获取学期成绩列表
// Axios.testingDetailStu = `${baseUrl}/ds1/mind/testingDetailStu`;  // 学生答题页面详情
// Axios.getTermWorkReportStu = `${baseUrl}/ds1/mind/getTermWorkReportStu`;  // 学生获取学期报告
// Axios.getWorkTestDetailStu = `${baseUrl}/ds1/mind/getWorkTestDetailStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
// Axios.getAllTestByClazz = `${baseUrl}/ds1/mind/getAllTestByClazz`;  // 根据课程获取试题（题库选题）

Axios.getTestDetailByMind = `${baseUrl}/ds1/mind/getTestDetailByMind`;  // 通过精神谱系获取测试题目内容（默认作业）
Axios.getAllTestByMind = `${baseUrl}/ds1/mind/getAllTestByMind`;  // 据精神谱系获取试题（题库选题）
Axios.commitTestByMind = `${baseUrl}/ds1/mind/commitTestByMind`;  // 学生获取测试题（作业详情和作答时候都使用此接口）

// Axios.getWorkDetailStu = `${baseUrl}/ds1/mind/getWorkDetailStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
// Axios.commitTestStu = `${baseUrl}/ds1/mind/commitTestStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
// Axios.commitAllTestStu = `${baseUrl}/ds1/mind/commitAllTestStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
// Axios.getWorkDetailTea = `${baseUrl}/ds1/mind/getWorkDetailTea`;  // 获取精神谱系序章

// Axios.commitTestByVovi = `${baseUrl}/ds1/clazz/commitTestByVovi`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
// Axios.commitTestByVr = `${baseUrl}/ds1/clazz/commitTestByVr`;  // 学生获取测试题（作业详情和作答时候都使用此接口）

//2023/3/23更新
Axios.uploadCloudFile1 = `${baseUrl}/ds1/center/uploadCloudFile1`; // 教师上传云文件1
Axios.getpreLogin = `${baseUrl}/ds1/user/preLogin`; //登录获取key。新增接口
Axios.getfavVovi = `${baseUrl}/ds1/center/favVovi`; //收藏全景
Axios.getCloudDlUrl = `${baseUrl}/ds1/center/getCloudDlUrl`; //获取云资源的下载链接
Axios.getTaskDlUrl = `${baseUrl}/ds1/tasked/getTaskDlUrl`; //获取任务下载链接
Axios.getVrDlUrl = `${baseUrl}/ds1/vr/getVrDlUrl`; //获取仿真资源的下载链接
Axios.getVoviDlUrl = `${baseUrl}/ds1/vovi/getVoviDlUrl`; //获取全景资源的下载链接
Axios.getMovieDlUrl = `${baseUrl}/ds1/movie/getMovieDlUrl`; //获取影视资源的下载链接
Axios.getMindClazzDlUrl = `${baseUrl}/ds1/mindClazz/getMindClazzDlUrl`; //获取思政课程下载链接
Axios.getMindDlUrl = `${baseUrl}/ds1/mind/getMindDlUrl`; //获取精神谱系资源的下载链接
Axios.getMindClazzPreface = `${baseUrl}/ds1/mindClazz/getMindClazzPreface`; // 获取思政课程序言
Axios.getMoviePreface = `${baseUrl}/ds1/movie/getMoviePreface`; // 获取影视资源序言
Axios.getMindClazzRvUrl = `${baseUrl}/ds1/mindClazz/getMindClazzRvUrl`; // 获取思政课程预览链接
Axios.getVoviTypeInfo_home = `${baseUrl}/ds1/user/getVoviTypeInfo`; // 获取思政课程首页内容不需要登录
// 收藏
Axios.getFavPathList = `${baseUrl}/ds1/center/getFavPathList`; // 列出当前路径下的收藏文件夹
Axios.removeFav = `${baseUrl}/ds1/center/removeFav`; // 删除收藏
Axios.favVR = `${baseUrl}/ds1/center/favVR`; // 收藏VR
Axios.favMovie = `${baseUrl}/ds1/center/favMovie`; // 收藏精神谱系视频
Axios.favFile = `${baseUrl}/ds1/center/favFile`; // 收藏文件（素材）
Axios.searchFav = `${baseUrl}/ds1/center/searchFav`; // 搜索收藏夹，返回收藏内容
Axios.getNewClazzList = `${baseUrl}/ds1/center/getNewClazzList`; // 获取课程列表
Axios.addNewClazz = `${baseUrl}/ds1/center/addNewClazz`; // 创建课程
Axios.removeNewClazz = `${baseUrl}/ds1/center/removeNewClazz`; // 删除课程
Axios.editNewClazz = `${baseUrl}/ds1/center/editNewClazz`; // 编辑课程

Axios.addFavPath = `${baseUrl}/ds1/center/addFavPath`; // 创建收藏文件夹
Axios.favHtml = `${baseUrl}/ds1/center/favHtml`; // 收藏html（概述；解读）
Axios.favTeaGuide = `${baseUrl}/ds1/center/favTeaGuide`; // 收藏教师导引
Axios.favStuGuide = `${baseUrl}/ds1/center/favStuGuide`; // 收藏学习导引
Axios.favTest = `${baseUrl}/ds1/center/favTest`; // 收藏测试题
Axios.favPathIsEmtity = `${baseUrl}/ds1/center/favPathIsEmtity`; // 判断收藏夹是否为空
Axios.getFavContent = `${baseUrl}/ds1/center/getFavContent`; // 获取收藏内容
Axios.getFavList = `${baseUrl}/ds1/center/getFavList`; // 列出当前文件夹下的收藏内容，不包括收藏夹
Axios.removeFavPath = `${baseUrl}/ds1/center/removeFavPath`; // 删除收藏文件夹，应先判断收藏夹是否为空，对用户进行提醒
Axios.getFavContentWithRealUrl = `${baseUrl}/ds1/center/getFavContentWithRealUrl`; //
Axios.addFilePath = `${baseUrl}/ds1/center/addFilePath`; //创建文件夹
Axios.getFileList = `${baseUrl}/ds1/center/getFileList`; //获取文件列表
Axios.uploadCloudFile2 = `${baseUrl}/ds1/center/uploadCloudFile2`; //教师上传云文件2
Axios.searchFile = `${baseUrl}/ds1/center/searchFile`; //搜索文件
Axios.editFilePath = `${baseUrl}/ds1/center/editFilePath`; //修改文件夹
Axios.editFile = `${baseUrl}/ds1/center/editFile`; //修改文件信息
Axios.getCloudDlUrl = `${baseUrl}/ds1/center/getCloudDlUrl`; //获取云资源的下载链接
Axios.getCloudRvUrl = `${baseUrl}/ds1/center/getCloudRvUrl`; //获取云资源的预览链接
Axios.favIsExists = `${baseUrl}/ds1/center/favIsExists`; //判断是否已经收藏过
Axios.getMovieDetailById = `${baseUrl}/ds1/movie/getMovieDetailById`; //通过id获取影视详情
Axios.getMindRvUrl = `${baseUrl}/ds1/mind/getMindRvUrl`; //通过id获取影视详情
Axios.editFavPath = `${baseUrl}/ds1/center/editFavPath`; //通过id获取影视详情

//站内信
Axios.getNoticeReviceList = `${baseUrl}/ds1/user2/getNoticeReviceList`; // 获取收藏内容
Axios.sendNotice = `${baseUrl}/ds1/user2/sendNotice`; // 教师/领导发送自定义通知
Axios.getNoticeList = `${baseUrl}/ds1/user2/getNoticeList`; //获取已发送的通知列表
Axios.getNoticeDetail = `${baseUrl}/ds1/user2/getNoticeDetail`; //获取通知详情
//个人空间
Axios.getFilePathList = `${baseUrl}/ds1/center/getFilePathList`; // 获取文件夹列表
Axios.removeFilePath = `${baseUrl}/ds1/center/removeFilePath`; // 删除文件夹
Axios.filePathIsEmtity = `${baseUrl}/ds1/center/filePathIsEmtity`; // 判断文件夹是否为空
Axios.getFavListPage = `${baseUrl}/ds1/center/getFavListPage`; // 列出当前文件夹下的收藏内容，不包括收藏夹，分页
Axios.removeFile = `${baseUrl}/ds1/center/removeFile`; // 删除文件
Axios.getOtherRvUrl = `${baseUrl}/ds1/user2/getOtherRvUrl`; // 获取头像，封面的预览链接
Axios.getFavPathListPage = `${baseUrl}/ds1/center/getFavPathListPage`; // 列出当前路径下的收藏文件夹，分页


//更新
Axios.commitTestByClass = `${baseUrl}/ds1/mindClazz/commitTestByClass`; // 教师按照章节上传试题
Axios.commitWork = `${baseUrl}/ds1/work/commitWork`; // 通过课程章节获取测试题内容（默认作业）
Axios.getWorkListTea = `${baseUrl}/ds1/work/getWorkListTea`; // 教师获取作业列表
Axios.getTermWorkScoreList = `${baseUrl}/ds1/work/getTermWorkScoreList`; // 教师查看自己的学生成绩
Axios.getWorkScoreListTea = `${baseUrl}/ds1/work/getWorkScoreListTea`; // 教师查看自己的学生成绩
Axios.generaTermWorkScore = `${baseUrl}/ds1/work/generaTermWorkScore`; // 教师查看自己的学生成绩
Axios.getWorkListStu = `${baseUrl}/ds1/work/getWorkListStu`; // 教师按照章节上传试题
Axios.getTermListStu = `${baseUrl}/ds1/work/getTermListStu`; // 学生获取学期成绩列表
Axios.testingDetailStu = `${baseUrl}/ds1/work/testingDetailStu`;  // 学生答题页面详情
Axios.getTermWorkReportStu = `${baseUrl}/ds1/work/getTermWorkReportStu`;  // 学生获取学期报告
Axios.getWorkTestDetailStu = `${baseUrl}/ds1/work/getWorkTestDetailStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
Axios.getWorkDetailStu = `${baseUrl}/ds1/work/getWorkDetailStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
Axios.commitTestStu = `${baseUrl}/ds1/work/commitTestStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
Axios.commitAllTestStu = `${baseUrl}/ds1/work/commitAllTestStu`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
Axios.getWorkDetailTea = `${baseUrl}/ds1/work/getWorkDetailTea`;  // 获取精神谱系序章

Axios.getVoviDetail = `${baseUrl}/ds1/vovi/getVoviDetail`;  // 获取全景详情
Axios.getVoviPreface = `${baseUrl}/ds1/vovi/getVoviPreface`;  // 获取全景的序言
Axios.getVoviTypeInfo = `${baseUrl}/ds1/vovi/getVoviTypeInfo`; // 首页获取全景类型信息
Axios.getVoviTypeInfoWithPage = `${baseUrl}/ds1/vovi/getVoviTypeInfoWithPage`; // 首页获取全景类型信息
Axios.getVoviListByTpye = `${baseUrl}/ds1/vovi/getVoviListByTpye`;  // 根据全景分类获取全景列表
Axios.getAllVoviTypeList = `${baseUrl}/ds1/vovi/getAllVoviTypeList`; // 获取全景分类
Axios.getTeaVoviList = `${baseUrl}/ds1/vovi/getTeaVoviList`; // 教师获取全景列表
Axios.getVoviDetailx = `${baseUrl}/ds1/vovi/getVoviDetailx`; //
Axios.getVoviByMap = `${baseUrl}/ds1/vovi/getVoviByMap`; // 根据省份获取全景资源列表
Axios.getVoviByType = `${baseUrl}/ds1/vovi/getVoviByType`; // 根据分类获取全景资源列表
Axios.getVoviUrl = `${baseUrl}/ds1/vovi/getVoviUrl`; // 获取全景页面url
Axios.getProvNum = `${baseUrl}/ds1/vovi/getProvNum`; // 省份和对应全景数量
Axios.getAllTestByVovi = `${baseUrl}/ds1/vovi/getAllTestByVovi`; // 根据全景获取试题
Axios.getVoviUrl = `${baseUrl}/ds1/vovi/getVoviUrl`; // 获取在线研读内容
Axios.getAllVoviList = `${baseUrl}/ds1/vovi/getAllVoviList`; // 获取全景
Axios.commitTestByVovi = `${baseUrl}/ds1/vovi/commitTestByVovi`;  // 学生获取测试题（作业详情和作答时候都使用此接口）

Axios.commitTestByVr = `${baseUrl}/ds1/vr/commitTestByVr`;  // 学生获取测试题（作业详情和作答时候都使用此接口）
Axios.getAllTestByVr = `${baseUrl}/ds1/vr/getAllTestByVr`; // 根据VR获取试题
Axios.getVrPreface = `${baseUrl}/ds1/vr/getVrPreface`;  // 获取VR的序言
Axios.getVrListByType = `${baseUrl}/ds1/vr/getVrListByType`;  // 根据vr分类获取vr列表
Axios.getAllVrTypeList = `${baseUrl}/ds1/vr/getAllVrTypeList`; // 教师获取所有虚拟仿真VR分类
Axios.getTeaVRList = `${baseUrl}/ds1/vr/getTeaVRList`; // 教师获取虚拟仿VR真列表
Axios.getVrDetail = `${baseUrl}/ds1/vr/getVrDetail`;  // 获取vr详情
Axios.getVrTypeInfo = `${baseUrl}/ds1/vr/getVrTypeInfo`; // 首页获取VR体验分类信息
Axios.getVRListByTypeCount = `${baseUrl}/ds1/vr/getVRListByTypeCount`; // VR列表行数
Axios.getVrInfoList = `${baseUrl}/ds1/vr/getVrInfoList`; // 教师获取虚拟仿真VR

Axios.getAllTestByClazz = `${baseUrl}/ds1/mindClazz/getAllTestByClazz`;  // 根据课程获取试题（题库选题）
Axios.getTestDetailByClazz = `${baseUrl}/ds1/mindClazz/getTestDetailByClazz`; // 通过课程章节获取测试题内容（默认作业）
Axios.getFirstChapter = `${baseUrl}/ds1/mindClazz/getFirstChapter`; // 获取课程章节的1级分类
Axios.getMindFirst = `${baseUrl}/ds1/mind/getMindFirst`;  // 获取精神谱系序章
Axios.getTeachPlan = `${baseUrl}/ds1/mindClazz/getChapterDetail`; // 获取精神谱系内容
Axios.getClazzType = `${baseUrl}/ds1/mindClazz/getClazzType`;  // 获取课程分类
Axios.getMindClazzList = `${baseUrl}/ds1/mindClazz/getMindClazzList`; // 获取思政课程列表
Axios.getMindClazzChapterList = `${baseUrl}/ds1/mindClazz/getMindClazzChapterList`; // 获取思政课程章节列表

Axios.getMovieTypeSelect = `${baseUrl}/ds1/movie/getMovieTypeSelect`; // 教师获取所有影视类型下拉列表
Axios.getTeaMovieList = `${baseUrl}/ds1/movie/getTeaMovieList`; // 教师获取影视列表
Axios.getMovieTypeList = `${baseUrl}/ds1/movie/getMovieTypeList`; // 获取影视分类列表
Axios.getMovieSeriesList = `${baseUrl}/ds1/movie/getMovieSeriesList`; // 获取影视剧集列表
Axios.getMovieDetail = `${baseUrl}/ds1/movie/getMovieDetail`; //
Axios.getMovieRvUrl = `${baseUrl}/ds1/movie/getMovieRvUrl`; //获取影视播放链接
Axios.getMovieList = `${baseUrl}/ds1/movie/getMovieList`; // 获取影视列表
Axios.getMovieSeriesSelect = `${baseUrl}/ds1/movie/getMovieSeriesSelect`; // 教师获取影视剧集下拉列表
Axios.getMovieSelect = `${baseUrl}/ds1/movie/getMovieSelect`; // 教师获取影视下拉列表
// Axios.getMovieTypeListByPage = `${baseUrl}/ds1/user/getMovieTypeListByPage`; // 获取影视分类列表

Axios.getMyInfo = `${baseUrl}/ds1/user2/getMyInfo`; // 获取个人信息
Axios.getSigninDetail = `${baseUrl}/ds1/user2/getSigninDetail`; // 获取签到详情
Axios.getAllDepaList = `${baseUrl}/ds1/user2/getAllDepaList`; // 获取教师所带班级的所有院系
Axios.getTeacherData = `${baseUrl}/ds1/user2/getTeacherData`; // 领导获取教师的相关数据
Axios.getTaskData = `${baseUrl}/ds1/user2/getTaskData`; // 领导获取实践相关数据
Axios.getResource = `${baseUrl}/ds1/user2/getResource`;
Axios.getWorkData = `${baseUrl}/ds1/user2/getWorkData`;  // 领导获取作业相关数据

Axios.getAddrListSelect = `${baseUrl}/ds1/tasked/getAddrListSelect`; // 教师获取任务地点列表
Axios.getTeaTaskedList = `${baseUrl}/ds1/tasked/getTeaTaskedList`; // 教师获取任务列表
Axios.getTermId = `${baseUrl}/ds1/tasked/getTermId`; // 学生获取学期报告列表
Axios.commitTeaTask = `${baseUrl}/ds1/tasked/commitTeaTask`; // 教师下发任务
Axios.taskQuaCommitTask = `${baseUrl}/ds1/tasked/taskQuaCommitTask`; // 教师下发任务
Axios.getStuTaskedList = `${baseUrl}/ds1/tasked/getStuTaskedList`; // 学生获取任务列表
Axios.getTesThemType = `${baseUrl}/ds1/tasked/getTesThemType`; // 教师获取任务地点列表
Axios.getTeaTaskTplList = `${baseUrl}/ds1/tasked/getTeaTaskTplList`; // 教师获取虚拟仿VR真列表
Axios.correctTasked = `${baseUrl}/ds1/tasked/correctTasked`; // 教师批阅任务
Axios.correctReport = `${baseUrl}/ds1/tasked/correctReport`; // 教师批阅实践报告
Axios.getStuListByTasked = `${baseUrl}/ds1/tasked/getStuListByTasked`; // 教师通过任务获取学生列表
Axios.taskedOffByTea = `${baseUrl}/ds1/tasked/taskedOffByTea`; // 教师通过任务获取学生列表
Axios.getStuTaskedDetailByTea = `${baseUrl}/ds1/tasked/getStuTaskedDetailByTea`; // 教师获取学生的任务详情
Axios.getAdviseScore = `${baseUrl}/ds1/tasked/getAdviseScore`; // 教师获取建议分数
Axios.getCommentListSelect = `${baseUrl}/ds1/tasked/getCommentListSelect`; // 教师获取评语列表
Axios.getTeaTaskTplDetail = `${baseUrl}/ds1/tasked/getTeaTaskTplDetail`; // 教师获取任务模板详情
Axios.getStuTaskedDetail = `${baseUrl}/ds1/tasked/getStuTaskedDetail`; // 学生获取任务详情
Axios.stuCommitTasked = `${baseUrl}/ds1/tasked/stuCommitTasked`; // 学生提交任务
Axios.commitReport = `${baseUrl}/ds1/tasked/commitReport`; // 学生提交实践报告
Axios.getStuTaskedScore = `${baseUrl}/ds1/tasked/getStuTaskedScore`; // 学生获取任务分数
Axios.getStuTaskedReport = `${baseUrl}/ds1/tasked/getStuTaskedReport`; // 学生获取任务评定报告
Axios.getStuTermReport = `${baseUrl}/ds1/tasked/getStuTermReport`; // 学生获取学期报告
Axios.getReadOnline = `${baseUrl}/ds1/tasked/getReadOnline`; // 学生获取在线研读内容
Axios.taskQuaMoive = `${baseUrl}/ds1/tasked/taskQuaMoive`; // 获取在线观影信息
Axios.taskQuaVovi = `${baseUrl}/ds1/tasked/taskQuaVovi`; // 获取全景信息
Axios.taskQuaCommit = `${baseUrl}/ds1/tasked/taskQuaCommit`; // 获取全景信息
Axios.taskQuaMoiveCount = `${baseUrl}/ds1/tasked/taskQuaMoiveCount`; // 影视类型列表行数
Axios.taskQuaVoviCount = `${baseUrl}/ds1/tasked/taskQuaVoviCount`; // 省份和对应全景数量
Axios.getReadOnline = `${baseUrl}/ds1/tasked/getReadOnline`; // 获取在线研读内容
Axios.getActiviReport = `${baseUrl}/ds1/tasked/getActiviReport`; // 学生获取实践报告内容
Axios.taskedIsChecked = `${baseUrl}/ds1/tasked/taskedIsChecked`; //
Axios.getTaskedListByTea = `${baseUrl}/ds1/tasked/getTaskedListByTea`; // 教师获取所有任务列表
Axios.getStuListByTaskedCount = `${baseUrl}/ds1/tasked/getStuListByTaskedCount`; // 获取思政课程章节列表行数
Axios.getTaskedListByTea2 = `${baseUrl}/ds1/tasked/getTaskedListByTea2`; //
Axios.getReadOnlineContentTime = `${baseUrl}/ds1/tasked/getReadOnlineContentTime`; // 获取在线研读的内容和时间
Axios.getMovieTime = `${baseUrl}/ds1/tasked/getMovieTime`; // 获取在线观影时间任务时长和完成时长
Axios.getVoviContentTime = `${baseUrl}/ds1/tasked/getVoviContentTime`; //
Axios.updateTaskedTime = `${baseUrl}/ds1/tasked/updateTaskedTime`; //
Axios.saveDetail = `${baseUrl}/ds1/tasked/saveDetail`; //
Axios.getScoreByTea = `${baseUrl}/ds1/tasked/getScoreByTea`; //
Axios.getStuScoreByTaskedIdCount = `${baseUrl}/ds1/tasked/getStuScoreByTaskedIdCount`; //
Axios.getTermScoreListCount = `${baseUrl}/ds1/tasked/getTermScoreListCount`; //
Axios.getMovieDetailx = `${baseUrl}/ds1/tasked/getMovieDetailx`; //
Axios.getTermReportListStuCount = `${baseUrl}/ds1/tasked/getTermReportListStuCount`; //
Axios.getStuScoreByTaskedId = `${baseUrl}/ds1/tasked/getStuScoreByTaskedId`; //
Axios.generateScore = `${baseUrl}/ds1/tasked/generateScore`; //
Axios.getTermScoreList = `${baseUrl}/ds1/tasked/getTermScoreList`; //
Axios.taskQuaMoiveType = `${baseUrl}/ds1/tasked/taskQuaMoiveType`; //
Axios.taskQuaMoiveSeries = `${baseUrl}/ds1/tasked/taskQuaMoiveSeries`; //
Axios.taskQuaMoive = `${baseUrl}/ds1/tasked/taskQuaMoive`; //
Axios.taskQuaVoviType = `${baseUrl}/ds1/tasked/taskQuaVoviType`; //
Axios.taskQuaVovi = `${baseUrl}/ds1/tasked/taskQuaVovi`; //
Axios.getTermReportListStu = `${baseUrl}/ds1/tasked/getTermReportListStu`; //
Axios.getTermReportInfo = `${baseUrl}/ds1/tasked/getTermReportInfo`; //
Axios.getTermInfoByTea = `${baseUrl}/ds1/tasked/getTermInfoByTea`; //

Axios.getMindClazzListSecond = `${baseUrl}/ds1/mindClazz/getMindClazzListByType`; //
Axios.getMindClazzListByType = `${baseUrl}/ds1/mindClazz/getMindClazzListByType`;  // 获取思政课程列表
Axios.getMindClazzDetail = `${baseUrl}/ds1/mindClazz/getMindClazzDetail`; // 获取思政课程详情
Axios.getMindClazzDetailSecond = `${baseUrl}/ds1/mindClazz/getMindClazzDetail`; //获取课程详情
Axios.getChildChapter = `${baseUrl}/ds1/mindClazz/getChildChapter`; // 通过章节获取子章节

Axios.getClazzListSelect = `${baseUrl}/ds1/user2/getClazzListSelect`; // 教师获取全景列表
Axios.exchangePointList = `${baseUrl}/ds1/user2/exchangePointList`; //
Axios.exchangePointListCount = `${baseUrl}/ds1/user2/exchangePointListCount`; //
Axios.taskQuaGetTeaScore = `${baseUrl}/ds1/user2/taskQuaGetTeaScore`; //
Axios.logout = `${baseUrl}/ds1/user2/logout`; // 用户登出
Axios.passwd = `${baseUrl}/ds1/user2/passwd`; // 修改密码
Axios.signin = `${baseUrl}/ds1/user2/signin`; // 签到
Axios.editPhone = `${baseUrl}/ds1/user2/editPhone`; // 用户修改手机号码
Axios.changeAvatar = `${baseUrl}/ds1/user2/changeAvatar`; // 修改头像
Axios.getclazzMindDomain = `${baseUrl}/ds1/user2/getclazzMindDomain`; // 获取课程思政资源登录地址
Axios.getAllProfList = `${baseUrl}/ds1/user2/getAllProfList`; // 获取教师所带班级的所有专业
Axios.getAllClazzList = `${baseUrl}/ds1/user2/getAllClazzList`; // 获取教师所带的所有班级，根据专业进行过滤
Axios.getAllGradeList = `${baseUrl}/ds1/user2/getAllGradeList`; // 获取教师所带班级的级别列表，根据专业和院系过滤
Axios.exchangePoint = `${baseUrl}/ds1/user2/exchangePoint`; //
Axios.getTip = `${baseUrl}/ds1/tasked/getTip`; //





// import {
//   messageOne
// } from '@/api/messageOne';

// Vue.use(ElementUI)
// Vue.prototype.$messageOne = messageOne;
import Bus from "../router/bus";


let isShowMessageNotLogin = true;
var ajax = function(url, data, success) {
  $.ajax({
    type: "POST",
    url: url,
    data: data,
    dataType: "json",
    beforeSend: function(request) {
      request.setRequestHeader("token", window.localStorage.getItem("token"));
    },
    success: function(data) {
      // console.log(data);
      if (window.localStorage.getItem("isLoading") == 1) {
        Vue.$loading().close();
        window.localStorage.setItem("isLoading", 0);
      }
      if (data.code == "1001") {
        isShowMessageNotLogin = false;
        if (localStorage.getItem("token")) {
          Vue.$message({
            type: "error",
            message: "登录失效",
            offset: 180
          });
          // Bus.$emit("show_Login", "true");
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("role");
          window.localStorage.removeItem("name");
          window.localStorage.removeItem("taskedId");
          window.localStorage.removeItem("taskedName");
        } else if (isShowMessageNotLogin) {
          isShowMessageNotLogin = false;
          Vue.$message({
            type: "info",
            message: data.msg,
            offset: 180,
            onClose: function() {
              isShowMessageNotLogin = true;
            }
          });
        }
        setTimeout(function() {
          Vue.$router.push({ path: `/` });
        }, 1000);
        return;
      }

      if (data.code != "0") {
        if (!data.msg || data.msg.length == 0) {
          return;
        }
        Vue.$message({
          type: "error",
          message: data.msg,
          offset: 180
        });
      } else if (data.code == "0") {
        if (data.msg) {
          // 直接在页面提示返回的信息
          Vue.$message({
            type: "success",
            message: data.msg,
            offset: 180
          });
          setTimeout(function() {
            success(data);
          }, 1000);
        } else {
          success(data);
        }
      }
    },
    error: function(message) {
      Vue.$message({
        type: "error",
        message: "网络错误123",
        offset: 180
      });
    }
  });
};
// 判断是否已经登录
var isLogined = function(isShowMsg = false) {
  if (!localStorage.getItem("token")) {
    if(isShowMsg) {
      Vue.$message({
        type: "info",
        message: "请先登录",
        offset: 180
      });
    }
    return false;
  } else {
    return true;
  }
};
Axios.ajax = ajax;
Axios.isLogined = isLogined;
export default Axios;



// WEBPACK FOOTER //
// ./src/api/user.js